import React from 'react'
import CSLPlasma from '../assets/images/csl_logo_4.png'
import '../styles/desktopHeader.css'
import { useState } from 'react'
import { MdOutlineAccountCircle } from 'react-icons/md'
import { RiArrowDropDownLine } from 'react-icons/ri'
import { Link } from 'react-router-dom'
import { storageKeys } from "../constants/storage";
import * as Storage from '../utils/storage';

var token = Storage.getString(storageKeys.TOKEN);
var username = Storage.getJson(storageKeys.USER);
var firstName = Storage.getJson(storageKeys.FIRSTNAME);
var LastName = Storage.getJson(storageKeys.LASTNAME);

const DesktopHeader = () => {
    const [activeMenu, setActiveMenu] = useState()
    const [showDrop, setShowDrop] = useState(false)

    const menus = [
        {
            target: "_blank",
            link: "/",
            title: "Dashboard",
        },
    ]
    const logoutHandler = () => {
        localStorage.clear();
        window.location.href = "/login";
    };
    const manageHandler = () => {
        window.location.href = "/manage";
    };
    const changePasswordHandler = () => {
        window.location.href = "/change/password";
    };

    return (
        <div className='desktop_header d-lg-flex d-none sidebars'>
            <div className='container d-flex flex-row align-items-center p-0'>
                <Link to="/" rel="noopener noreferrer" className='h-100 d-flex align-items-center mr-1'>
                    <img alt='' src={CSLPlasma} style={{ width: '110px', marginLeft:"20px" }} />
                </Link>
                {token ?
                    <div className='row container'>
                        <div className='col-xxl-7 col-12 p-0 d-flex align-items-center'>
                        </div>
                        <div className='col-xxl-5 col-12 p-0 d-flex align-items-center justify-content-xxl-end' style={{ height: '80px' }}>
                            <div className='d-flex flex-row align-items-center'>
                                {
                                    menus.map((m, index) => (
                                        <div key={index} className="dropdown" style={{ cursor: "pointer" }}>
                                            <a
                                                onClick={() => {
                                                    if (m.link === "#") {
                                                    } else if (m.link === "#referral") {
                                                    } else {
                                                        setActiveMenu(m.link)
                                                    }
                                                }}
                                                onMouseOver={() => {
                                                    setShowDrop(!showDrop)
                                                    setActiveMenu(m.link)
                                                }}
                                                href={m.link}
                                                className='navigation_text showDrops' style={{ textDecoration: 'none', padding: '15px', color: 'black' }}>
                                                {m.title}
                                            </a>
                                            {
                                                m.children && m.children.length > 0 && (
                                                    <ul className={`dropdown-menu ${showDrop && m.link === activeMenu ? "show" : ""}`} show aria-labelledby="dropdownMenuButton1">
                                                        {
                                                            m.children && m.children.map((ch, Inch, index) => (
                                                                <li key={index}><a className="dropdown-item" href={ch.link}>{ch.title}</a></li>
                                                            ))
                                                        }
                                                    </ul>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                                <div className='d-flex flex-row align-items-center dropdown'>
                                    <div className="btn dropdown-toggle p-2" type="button" data-bs-toggle="dropdown">
                                        <MdOutlineAccountCircle size={40} />
                                        <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" style={{ fontSize: "14px", marginTop: "20px", marginLeft: '-10px' }}>
                                            <p className='m-0 text-capitalize' style={{ cursor: 'pointer', fontSize: '14px', fontWeight: 600 }}>{firstName} {LastName}</p>
                                            <p className='text-capitalize' style={{ cursor: 'pointer', fontSize: '14px' }}>{username && username}</p>
                                        </button>
                                        <RiArrowDropDownLine size={25} />
                                        <div className="dropdown-menu customMenu" aria-labelledby="dropdownMenuButton" >
                                            <Link style={{ cursor: 'pointer', fontSize: '14px', fontWeight: 600 }} onClick={() => {
                                                logoutHandler();
                                            }} className="dropdown-item">Log Out</Link>
                                            <Link className="dropdown-item" style={{ fontSize: "14px", fontWeight: 600 }} onClick={() => {
                                                changePasswordHandler();
                                            }}>Change Password</Link>
                                            <Link className="dropdown-item" style={{ fontSize: "14px", fontWeight: 600 }} onClick={() => {
                                                manageHandler();
                                            }}>Manage Users</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

            </div>
        </div>
    )
}

export default DesktopHeader